/* eslint-disable no-shadow */
enum TimeOccurrenceParameterEnum {
  EnableConditionalHoursBankFilter = "enableConditionalHoursBankFilter",
  EnableMandatoryDocsFilter = "enableMandatoryDocsFilter",
  AnyoneCanViewExceptions = "anyoneCanViewExceptions",
  EnableOvertimeJustification = "enableOvertimeJustification",
  EnableOvertimeApprovalReason = "enableOvertimeApprovalReason",
  AnyoneCanPreHandling = "anyoneCanPreHandling",
  AnyoneCanCreateOwnExcusedAbsence = "anyoneCanCreateOwnExcusedAbsence",
  DaysToSendDocumentBeforeOccurrence = "daysToSendDocumentBeforeOccurrence",
  CanCreateRetroativeExceptions = "canCreateRetroativeExceptions",
  EnablePreAbono = "enablePreAbono",
  HasHourControlExcusedAbsence = "hasHourControlExcusedAbsence",
  DisablePointTimeException = "disablePointTimeException",
  DisableTransferTimeShift = "disableTransferTimeShift"
}
export default TimeOccurrenceParameterEnum;
